import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // ✅ React Router hook
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Banner.css";
import Marquee from "../Marquee";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FiLoader } from "react-icons/fi";

import {
  newSky,
  selectSiteBanners,
} from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";
import { generatePresignedUrl } from "../../../../AsianExchangeSrc/utils/helper/generatePresignedUrl";

const newsItems = [
  {
    date: "07 Dec 2024",
    event: "New Zealand v England",
    market: "30 Over NZ '96.300.500' (IST 03:46:09 - 03:47:12)",
    message:
      "Bets Voided Because Wrong Rate Offered By Mistake .. Sorry for the Inconvenience Caused",
  },
  {
    date: "07 Dec 2024",
    event: "Victoria v Rangpur Riders",
    market: "11 Over VIC '89.75.125' (IST 07:32:54 - 07:33:10)",
    message:
      "Bets Voided Because of Wrong Rate Offered By Mistake .. Sorry for the Inconvenience Caused",
  },
];

const Banner = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const siteBanners = useSelector(selectSiteBanners());
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const SkyDesign = useSelector(newSky());

  const fetchBanners = async () => {
    setLoading(true);
    try {
      if (Array.isArray(siteBanners) && siteBanners.length > 0) {
        const bannersWithPresignedUrls = await Promise.all(
          siteBanners.map(async (banner) => {
            // if (!banner?.url || typeof banner.url !== "string") {
            //   console.error("Invalid banner URL:", banner);
            //   return null; // skip this banner
            // }

            const signedUrl = await generatePresignedUrl(banner?.url || banner); // ✅ Pass only the URL
            return {
              url: signedUrl,
              path: banner?.path || "",
            };
          })
        );

        setBanners(bannersWithPresignedUrls);
      } else {
        setBanners([]);
      }
    } catch (error) {
      console.error("Error fetching banners:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (siteBanners) {
      fetchBanners();
    }
  }, [siteBanners]);

  useEffect(() => {
    const updateScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    updateScreenSize();
    window.addEventListener("resize", updateScreenSize);
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);



// if (loading) {
//   return (
//     <div className="w-full h-[73px] mt-[1px] md:h-[250px] bg-black flex items-center justify-center">
//       <FiLoader className="text-white text-4xl animate-spin" />
//     </div>
//   );
// }


  return (
    <div className="slider-container mt-[1px]">
      <div className={`desk-marquee ${userId ? "login-marquee" : ""}`}>
        <Marquee newsItems={newsItems} />
      </div>

      {banners.length > 0 && (
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          showStatus={false}
          showArrows={!isMobile}
          showIndicators={!isMobile}
          renderArrowPrev={(onClickHandler, hasPrev) =>
            hasPrev && (
              <button
                type="button"
                className="absolute left-0 top-1/2 transform -translate-y-1/2 p-2 text-white z-10"
                onClick={onClickHandler}
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext) =>
            hasNext && (
              <button
                type="button"
                className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 text-white z-10"
                onClick={onClickHandler}
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            )
          }
        >
          {banners.map((item, index) => (
            <div
              key={index}
              className="cursor-pointer"
              onClick={() => {
                if (item.path) navigate(`/${item.path}`);
              }}
            >
              <img
                src={item?.url || item || ""}
                alt={`Banner ${index + 1}`}
                loading="lazy"
                className="w-full object-cover"
              />
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default Banner;
